
import { Vue } from 'vue-class-component'
import store from '../store'
export default class Head extends Vue {
  d = store.getters['company/get']
}
